export default Object.freeze({
  byTag: [],
  byDateAndTag: [],
  byDate: [],
  loading: true,
});
